export default class Document {
  public static readonly GET_PRESIGNED_URL = '/document/uploadurl';
  public static readonly GET_EOB_DOCUMENTS = '/document/eob';
  public static readonly CREATE = '/documents/create';
  public static readonly GET_UPLOADED_DOCS = '/document/getuploaded';
  public static readonly DELETE_UPLOADED_DOCS = '/document/{id}';
  public static readonly GET_PRESIGNED_URL_DOWNLOAD = '/document/downloadurl';
}
